import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Row, Col, Button } from 'antd';
import { history } from '../../redux/store';

type Props = {};

const HowItWorks: React.FC<Props> = () => {
  const { t } = useTranslation('genericScreen');
  const badges = useSelector((state: IReducerStates) => state.global.badges);
  const user = useSelector((state: IReducerStates) => state.global.user);
  return (
    <>
      <Row
        justify="center"
        align="top"
        style={{ marginTop: '40px', maxWidth: '1400px', margin: '40px auto' }}
      >
        <Col
          xs={24}
          sm={18}
          md={18}
          lg={18}
          xl={18}
          style={{ background: '#fff', padding: '20px' }}
        >
          <h1 className="title pt20">{t('how_it_works')}</h1>
          <picture>
            <source type="image/webp" srcSet="/Levels-FlowChart.webp" />
            <source type="image/jpeg" srcSet="/Levels-FlowChart.jpg" />
            <img width="100%" src="/Levels-FlowChart.jpg" />
          </picture>
          <h1 className="title pt20">Step 1</h1>
          <p className="text">
            Firstly, create your account and register your dog/s so you can track their progress.
          </p>
          <h1 className="title pt20">Step 2</h1>
          <p className="text">
            Then check out the Core programme page! You will see all the details for levels 1 to 8
            of the University programme, each level contains 10 tricks. Each level gradually
            increases in difficulty (and points to be gained) but you will be well prepared for
            every challenge as you progress through the levels. It’s best to start at level 1 but
            you can start at a higher level if you have mastered all of the tricks in the previous
            levels.
          </p>
          <h1 className="title pt20">or</h1>
          <p className="text pt10">
            If you would prefer to design your own programme instead, then you can do that! Check
            out the Trick library page where you can buy tricks individually. Tricks vary in
            difficulty from 5 points to 25 points, the more advanced tricks often have skills you
            need to have mastered first, so check out the prerequisite section in each tricks
            description.
          </p>
          <p className="text pt10">
            Bonus courses are also available which are great ways of earning extra points! These are
            often fun groups of tricks based around a particular theme. There are also some agility
            skills short courses available there too!
          </p>
          <h1 className="title pt20">Step 3</h1>
          <p className="text">
            When you buy a trick it will be added to your dog’s profile page and you are ready to
            start!
          </p>
          <p className="text pt10">
            You will see a demo video for each trick, along with a written guide. When you are
            ready, you can post your own short videos (1 min max) for help & advice or just to show
            off when it’s going well! Every trick will be available to you for 3 months from the
            date of purchase.
          </p>
          <h1 className="title pt20">Step 4</h1>
          <p className="text">
            Every trick that you complete, earns you points! These points earn you titles and badges
            added to your dogs profile. Top point scorers will appear on our leader board and be in
            the running for some great prizes! Dogs living in the UK and Europe will also receive a
            rosette in the post every time they achieve a title.
          </p>
          <Row justify="center" align="top" style={{ padding: '10px 20px ' }}>
            {badges &&
              badges.data &&
              badges.data.length > 0 &&
              badges.data.map((item, index) => {
                if (item.points > 1 && item.points < 9999) {
                  return (
                    <div key={index} style={{ position: 'relative', paddingBottom: '25px' }}>
                      <img
                        style={{
                          borderRadius: '100px',
                          float: 'left',
                          marginRight: '30px',
                          width: '120px'
                        }}
                        className="small-pic"
                        src={item.thumb + '?s=small'}
                      />
                      <span
                        className="text"
                        style={{ position: 'absolute', bottom: '0', left: '35%' }}
                      >
                        {item.points}
                      </span>
                    </div>
                  );
                }
              })}
          </Row>

          {user && (
            <Row justify="center" align="top" style={{ padding: '10px 20px ' }}>
              <Button
                type="primary"
                onClick={() => history.push('/free-shaping')}
                target="_blank"
                className="btn-big"
              >
                <span>Watch our Free Shaping video now!</span>
              </Button>
            </Row>
          )}
        </Col>
      </Row>
    </>
  );
};

export default HowItWorks;
